export default {
  name: "al-core-view",

  components: {},

  computed: {},
};

